// Similar to useAfterRenderCallback, but allows for dynamic callbacks to be passed in
// and makes it easy to use in conditional rendering e.g.
// const after = useCallback(useAfterRenderCallback, []);
// return (
//   <div>
//     {isActive && <button onClick={after(onChange)}>Apply</button>
//   </div>
// )

type Callback<P> = (...args: P[]) => void;

const afterRenderCallback = <P extends any>(cb: Callback<P>): Callback<P> => (
  ...args: P[]
): void => {
  requestAnimationFrame(() => requestAnimationFrame(() => { cb(...args); }));
};

export default afterRenderCallback;
